import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = [
  {
    title: '热门分类',
    links: categories.slice(0, 4).map((cat) => ({
      label: cat.name,
      href: `/category/${cat.slug}`,
    })),
  },
  {
    title: '更多内容',
    links: categories.slice(4).map((cat) => ({
      label: cat.name,
      href: `/category/${cat.slug}`,
    })),
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户口碑', href: '/about#reviews' },
      { label: '品牌故事', href: '/about#story' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/4">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-950">今日看料</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                今日看料网——吃瓜群众的一线热点追踪站。聚合网红爆料、娱乐圈八卦、热点事件等实时内容，为您提供最新最热的看料体验。今日看料入口与下载尽在掌握。
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg bg-foreground-950 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-background-50 text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg bg-foreground-950 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-background-50 text-base"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              {footerLinks.map((section) => (
                <div key={section.title}>
                  <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
                    {section.title}
                  </h4>
                  <ul className="flex flex-col gap-2.5">
                    {section.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.href}
                          className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 今日看料 JinRiKanLiao.com 版权所有 | 仅供娱乐参考
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">用户协议</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}